<div class="container-fluid h-100 py-3">
  <div class="row h-100">
    <div class="col flex-grow-1">
      <app-company-vendor-files-grid
        [gridName]="'ClientVendorDocuments'"
        [suppliedQueryData]="suppliedGridQuery"
      ></app-company-vendor-files-grid>
    </div>
  </div>
</div>
